<template>
  <div class="customCode">
    <label>Components:</label>
    <ul>
      <li v-for="(component, key) in components" :key="key" class="customCode__item">
        <a href="#" @click.prevent="edit(key)">{{ component.name }}</a>
        <a
          href="#"
          class="customCode__removeCode"
          @click.prevent="remove(key)"
        >
          <icon name="remove" />
        </a>
      </li>
    </ul>
    <b-button variant="primary" size="sm" @click="create" class="customCode__addBtn">
      <icon name="plus" />Create
    </b-button>
    <CustomComponentModal ref="customComponentCreateModal" :components="components" />
    <CustomComponentModal
      ref="customComponentEditModal"
      title="Edit Component"
      :components="components"
    />
  </div>
</template>

<script>
// components
import CustomComponentModal from './modals/CustomComponent'
// services
import db from '@/services/db'

export default {
  components: {
    CustomComponentModal,
  },
  data() {
    return {
      components: null,
    }
  },
  methods: {
    create() {
      this.$refs.customComponentCreateModal.open()
    },
    edit(key) {
      this.$refs.customComponentEditModal.open({
        ...this.components[key],
        editKey: key,
      })
    },
    remove(key) {
      if (confirm('Are you sure?')) db.components.remove(key)
    },
  },
  created() {
    db.components.read(components => {
      this.components = components
    })
  },
}
</script>
